<template>
  <div>

    <el-dialog
        @keydown.enter.native="saveForm"
        :title="device.title"
        :visible="visible"
        width="618px"
        @open="onOpen"
        :before-close="close"
        :loading="loading"
    >
      <el-row v-loading="loading">
        <el-col :span="24">
          <div v-for="item of answers" :key="item.id">

            <el-row v-if="item.file_input_field" type="flex" align="center" :gutter="5" class="file-upload">
              <el-col :span="item.file_input_field ? 12 : 24">
                <div class="file-upload__title">{{ item.title }}</div>
              </el-col>
              <el-col :span="12" class="file-upload__title_left" v-if="false && item.file_input_field">
                <el-button
                    :disabled="item.file_count <= countFiles(item.id)"
                    size="small"
                    type="primary"
                    icon="el-icon-link"
                    @click="addFile(item.id)"
                >Прикрепить документ
                </el-button>
              </el-col>

            </el-row>
            <el-row>
              <el-col :span="24" class="">

                <upload-file v-for="file of item.file" :key="file.id" :file="file"
                             @openPhoto="openPhoto"
                             @delete="fileDelete(item.id, file.id)"
                >

                </upload-file>

                <el-form
                    v-show="!item.file_input_field"
                    :model="item"
                    :ref="'DeviceFormItem' + item.id"
                    class="form-devices"
                >
                  <el-form-item
                      prop="value"
                      :rules="[
                      item.field_value ? { pattern:  new RegExp(item.field_value.mask), message: item.field_value ? item.field_value.hint : 'Ошибка формата', trigger: ['blur', 'change'] } : {}
                 ]">
                    <el-row type="flex" justify="center">
                      <el-col :span="18">
                        <div class="form-devices__title">{{ item.title }}</div>
                      </el-col>
                      <el-col :span="6">
                        <el-input
                            v-if="item.input_field"
                            autosize
                            v-model.lazy="item.value"
                            @input="autoFormat($event, item)"
                            :placeholder="item.field_value ? item.field_value.placeholder : ''"
                        ></el-input>
                        <el-input
                            v-model="item.value"
                            v-show="false"
                        ></el-input>
                      </el-col>

                    </el-row>


                  </el-form-item>
                </el-form>


                <el-alert
                    v-if="item.file_input_field && item.file_count <= countFiles(item.id)"
                    :closable="false"
                    :title="`Максимальное количество файлов - ${item.file_count}`"
                    type="warning">
                </el-alert>


                <div @mouseenter="selectFileUpload = item">
                  <el-upload
                      v-if="item.file_input_field"
                      :ref="'uploadFile' + item.id"
                      list-type="picture-card"
                      :action="upload.URL"
                      :limit="item.file_count"
                      :class="[item.file_count <= countFiles(item.id) ? 'noUpload' : '']"
                      :on-success="sendFieldsFile"
                      :on-error="errorFieldsFile"
                      :before-upload="beforeSendFieldsFile"

                      handleExceed
                      drag
                      :headers="fileHeaders()"
                      name="upload"
                      :on-remove="handleRemove"
                      class="form-devices__upload"
                      :auto-upload="true"
                  >

                    <i slot="default" class="el-icon-plus"></i>
                    <div slot="file" slot-scope="{ file }">
                      <div v-if="file.response">
                        <img class="el-upload-list__item-thumbnail"
                             :src="file.url" v-if="mapTypeFiles(file.response.ext)"
                             alt/>
                        <img class="el-upload-list__item-thumbnail"
                             src="@/assets/icon-file.svg"
                             v-else
                             alt/>
                      </div>
                      <span class="el-upload-list__item-actions">

                        <span
                            v-if="!disabled"
                            class="el-upload-list__item-delete"
                            @click="fileDownload(file.response)"
                        >
                          <i class="el-icon-download"></i>
                        </span>
                        <span
                            v-if="!disabled"
                            class="el-upload-list__item-delete"
                            @click="remoteFile(item.id, file)"
                        >
                         <i class="el-icon-circle-close"></i>
                        </span>

                      </span>
                    </div>
                  </el-upload>
                </div>
              </el-col>
            </el-row>

          </div>

        </el-col>
      </el-row>


      <footer-buttons mt>
        <!--        <el-button @click="close">Закрыть</el-button>-->
        <el-button type="primary" @click="saveForm" :disabled="loading">Сохранить</el-button>
      </footer-buttons>


    </el-dialog>

    <el-dialog
        title="Просмотр фото"
        :visible.sync="dialogShowPhoto"
        width="70%"
        class="dialog-show-photo"
    >
      <img :src="getUrlPhoto(selectPhoto)" :alt="getUrlPhoto(selectPhoto)" class="dialog-show-photo__img">
      <span slot="footer" class="dialog-footer">
        <el-button @click="fileDownload(selectPhoto)">Скачать</el-button>
        <el-button type="primary" @click="dialogShowPhoto = false">Закрыть</el-button>
      </span>
    </el-dialog>

  </div>
</template>

<script>
import Cookie from "js-cookie";
import {mapGetters} from "vuex";
import FooterButtons from "@/components/dialog/FooterButtons"
import UploadFile from "@/components/documents/UploadFile"

export default {
  name: "EditDeviceModal",
  data() {
    return {
      selectFileUpload: null,
      loading: null,
      load: false,
      answers: {},
      oldAnswers: {},
      selectPhoto: "",
      dialogShowPhoto: false,
      disabled: false,
      form: null,
      error: null,
      imageData: null,
      allDocuments: {},
      fileList: []
    };
  },
  props: {
    device: {
      required: true,
    },
    visible: {
      required: true,
    }
  },
  mounted() {
    this.initNativeListeners()
  },
  beforeDestroy() {
    this.destroyNativeListeners();
  },
  components: {
    FooterButtons,
    UploadFile
  },
  computed: {
    ...mapGetters("session", {session: "session"}),

    upload() {
      return {
        URL: process.env.VUE_APP_ADMIN_API_BASE_URL + "/file/upload",
        data: {},
        headers: {
          Access: "application/json",
          "Accept-Language": "ru",
          "X-Requested-With": "XMLHttpRequest",
          "access-control-allow-origin": "*",
        },
      }
    }
  },
  methods: {
    initNativeListeners() {
      document.addEventListener('keyup', this._onKeyup)
    },
    destroyNativeListeners() {
      document.removeEventListener('keyup', this._onKeyup)
    },
    _onKeyup(event) {
      event = event || {}

      if ((!this.loading) && event.key === 'Enter') this.saveForm()
    },
    getUrlPhoto(file) {
      return this.$root.getUrlPhoto(file.link.get)
    },
    mapTypeFiles(type) {
      return type === 'jpeg' || type === 'jpg' || type === 'png'
    },
    autoFormat(value, event) {
      event.value = value.replace(",", ".");
    },
    onOpen() {

      if (!this.session) {
        this.$emit('close', this.device.id)
      } else this.loadLogic();

    },
    close() {


      if (JSON.stringify(this.oldAnswers) != JSON.stringify(this.answers)) {

        this.$confirm('Имеются не сохранные изменения. Продолжить?', 'Изменения не сохранены', {
          confirmButtonText: 'Закрыть',
          cancelButtonText: 'Продолжить редактирование',
          type: 'warning'
        }).then(() => {
          this.loading = true
          this.$emit('close', this.device.id)
        }).catch(() => {

        })
      } else {
        this.loading = true
        this.$emit('close', this.device.id)
      }

    },
    loadLogic() {
      this.answers = {};
      let answers = {};

      this.allDocuments = {}

      this.loading = true
      this.$api.devices
          .device(this.session.id, this.device.id)
          .then((response) => {
            let dataS = {};
            response.data.forEach((item) => {
              dataS[item.diagnostic_field_id] = {}
              dataS[item.diagnostic_field_id].value = item.input
              dataS[item.diagnostic_field_id].idPost = item.id
              dataS[item.diagnostic_field_id].file = item.file
            });

            this.device.diagnostic_field.forEach((item) => {
              answers[item.id] = Object.assign(
                  dataS[item.id] ? dataS[item.id] : {},
                  item
              )
            })

            response.data.forEach((item) => {
              let files = []
              item.file.forEach((file) => {
                files.push(file.id)
              })
              if (files.length !== 0) this.allDocuments[item.diagnostic_field_id] = files;
            })

            this.oldAnswers = JSON.parse(JSON.stringify(answers))
            this.answers = answers

          })
          .catch((res) => {
            this.$notify.error({
              title: "Ошибка загрузки данных 😕",
              message: res.response.data.message,
            });
          })
          .finally(() => {
            this.loading = false
          })
    },
    fileHeaders() {
      return {
        Authorization: `Bearer ${this.trimCookie(
            Cookie.get("access_token")
        )}`
      }
    },
    trimCookie(cookie) {
      return cookie ? cookie.replace(/[А-Яа-я]/gi, "") : "";
    },
    addFile(id) {
      this.$refs["uploadFile" + id][0].$children[
      this.$refs["uploadFile" + id][0].$children.length - 1].handleClick();
    },
    remoteFile(id, file) {
      this.$refs["uploadFile" + id][0].handleRemove(file)

      this.fileDelete(id, file.response.id)
    },
    errorFieldsFile() {
      this.loading = !!0
      this.$notify.error({
        title: "Ошибка отправки файла 😕",
        message: "Попробуйте открыть окно еще раз и повторите загрузку файла",
      })
    },
    sendFieldsFile(value) {

      this.loading = false

      if (!value) return
      let data = {
        diagnostic_field_id: this.selectFileUpload.id,
        uFile: [value.id],
      };

      this.$notify.success({
        title: "Файл был загружен",
        message: "Не забудьте сохранить изменения",
      })

      this.$forceUpdate()
      let filesIs = this.allDocuments[this.selectFileUpload.id] ? this.allDocuments[this.selectFileUpload.id] : []
      this.allDocuments[this.selectFileUpload.id] = [...filesIs, ...data.uFile]
    },
    saveForm() {
      if (!this.visible) return

      let cancel = false
      let answers = Object.keys(this.answers).map((key) => {

        this.$refs['DeviceFormItem' + key][0].validate((valid) => {
          if (!valid) {
            this.$notify.error({
              title: 'Ошибка валидации 😕',
              message: 'Поле: «' + this.answers[key].title + '» не прошло валидацию'
            });
            cancel = true
          }
        })

        return {
          input: this.answers[key].value ? this.answers[key].value : '',
          diagnostic_field_id: this.answers[key].id,
          file: this.allDocuments[this.answers[key].id] ? this.allDocuments[this.answers[key].id] : []
        }
      })

      if (cancel) return

      this.loading = !!1;
      this.$api.devices.edit(this.session.id, answers)
          .then((res) => {
            this.$notify.success({
              title: 'Успешно',
              message: 'Данные сохранены'
            })

            this.oldAnswers = JSON.parse(JSON.stringify(this.answers))
            this.close()

            this.$set(this.device, 'complete_data', true)
            if (res.data.id) this.answers[res.data.diagnostic_field_id].idPost = res.data.id;
          })
          .catch((res) => {
            this.$notify.error({
              title: "Упс..",
              message: res.response.data.message,
            })
          })
          .finally(() => {
            this.loading = !!0;
          })

    },
    beforeSendFieldsFile() {
      this.loading = !!1
    },
    openPhoto(file) {
      this.dialogShowPhoto = true
      this.selectPhoto = file
    },
    filePreview(id) {
      this.$api.devices
          .fileView(id.response.id)
          .then(() => {
          })
          .catch(() => {
            this.$notify.error({
              title: "Ошибка загрузки файла 😕",
              message: "",
            })
          })
    },
    fileDownload(file) {
      this.dialogShowPhoto = false

      this.$notify.success({
        title: "Подготовка к скачиванию",
        message: 'Ожидайте загрузки файла',
      })

      this.$api.devices
          .fileDownload(file.id)
          .then((response) => {
            const downloadFile = require("js-file-download")
            downloadFile(response.data, file.full_title)
            this.imageData = response.data
          })
          .catch((response) => {
            this.$notify.error({
              title: "Ошибка загрузки файла 😕",
              message: response.response.data.message,
            })
          })
    },
    fileDelete(diagnostic_field_id, id_file) {
      let arr = [...this.allDocuments[diagnostic_field_id]]
      let index = arr.findIndex((e) => e === id_file)
      arr.splice(index, 1)
      this.$set(this.allDocuments, diagnostic_field_id, arr)

      let answers = {...this.answers}
      let diagnostic_field = answers[diagnostic_field_id].file
      if (diagnostic_field) {
        diagnostic_field.splice(index, 1)
        answers[diagnostic_field_id].file = diagnostic_field
      }

      this.$forceUpdate()
    },
    handleRemove(file, item) {
      console.log(file.response.id)
      console.log('item', item)
    },
    countFiles(field) {
      if (!this.allDocuments[field]) return 0
      return this.allDocuments[field].length
    }

  }

}
</script>

<style scoped lang="scss">

.file-upload {
  align-items: center;
  margin: 20px 0 10px 0;

  &__title {
    font-weight: 600;
    font-size: 16px;

    line-height: 26px;
    color: #111;

    &_left {
      text-align: end;
    }
  }
}

.form-devices {

  border-bottom: 1px solid #EAEAEA;
  padding-top: 8px;

  /deep/ .el-form-item--mini.el-form-item {
    margin-bottom: 8px !important;
  }

  &__title {
    line-height: 40px;

    &_left {
      text-align: end;
    }
  }


  &__btns {
    text-align: center;
    margin: 50px 0 0 0;
  }


  &__btn {
    margin-left: 5px;
  }
}

.el-dialog__wrapper {
  /deep/ {
    .el-dialog__header {
      border-bottom: 1px solid #EAEAEA;
      padding: 27px 48px 27px 48px !important;
      font-weight: 600;
      font-size: 20px;


    }

    .el-dialog__headerbtn {
      display: none;
    }

    .el-upload-dragger {
      width: 100px;
      height: 100px;
    }

    .form-devices__upload {
      border-bottom: 1px solid #EAEAEA;
      padding-bottom: 8px;
    }

    .el-upload-list--picture-card .el-upload-list__item {
      width: 100%;
      height: 48px;
      border: none;
      border-radius: 0;
    }
    .el-upload-list__item-thumbnail {
      border-radius: 4px;

      margin-top: 4px;
      width: 40px;
      height: 40px;
    }
    .el-upload--picture-card, .el-upload-dragger {
      width: 40px;
      height: 40px;

      line-height: 47px;
    }
    .el-upload--picture-card {
        border: 0;
    }
    .el-upload-list--picture-card .el-upload-list__item-actions {
      position: absolute;
      width: 100px;
      height: 100%;
      /* left: 0; */
      right: 0;
      left: auto;
      cursor: default;
      text-align: center;
      color: #111;
      opacity: 1;
      font-size: 20px;
      background: none;
      transition: opacity .3s;

      & span {
        display: inline-block;
      }
    }


    .el-form-item__error {
      top: 80%
    }
  }
}

.file-list {
  display: flex;
  align-items: center;
  justify-content: space-between;

  margin-top: 15px;
  font-size: 14px;

  background: #efefef;
  padding: 10px 5px;
  border-radius: 5px;
}

.description {
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 1;

  color: #aaaeba;
  margin: 25px 0 10px 0;

  &_mini {
    font-size: 14px;
  }
}

.dialog-show-photo {
  &__img {
    width: 100%;
  }
}

.noUpload /deep/ .el-upload {
  display: none;
}


.form-devices {
  &__upload {
    margin-bottom: 20px;


  }
}
</style>
